<template>
<div class="comment-user-info">
  <div class="comment-user-info__block">
    <div class="comment-user-info__abater"><span class="img-triming"><img :src="avatarUrl"></span></div>
  </div>
  <div class="comment-user-info__block">
    <div class="comment-user-info__name">{{userData.display_name}}</div>
    <div class="time-stamp" v-if="timeStamp">{{getTimeStamp}}</div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'userInfo',
  props: {
    userData: Object, // ログインユーザー、コメントユーザー二通り
    timeStamp: Number
  },
  computed: {
    ...mapState('commentsData', ['commentsLength']),
    getTimeStamp: function () {
      const unixTime = Number(this.timeStamp)
      const date = new Date(unixTime)
      const diff = new Date().getTime() - date.getTime()
      const d = new Date(diff)
      if (d.getUTCFullYear() - 1970 || d.getUTCMonth()) {
        // n年n月n日
        // 1505228400
        // 1170311833000
        const sd = date
        const year = sd.getFullYear()
        const month = sd.getMonth() + 1
        const day = sd.getDate()
        const hour = sd.getHours()
        const minutes = sd.getMinutes()
        const second = sd.getSeconds()
        return year + '年' + month + '月' + day + '日' + hour + '時' + minutes + '分' + second + '秒'
      } else if (d.getUTCDate() - 1) {
        return d.getUTCDate() - 1 + '日前'
      } else if (d.getUTCHours()) {
        return d.getUTCHours() + '時間前'
      } else if (d.getUTCMinutes()) {
        return d.getUTCMinutes() + '分前'
      } else {
        return d.getUTCSeconds() + '秒前'
      }
    },

    avatarUrl: function () {
      return (this.userData.avatar_url !== 'noimage' && this.userData.avatar_url !== '' && this.userData.avatar_url !== undefined) ? this.userData.avatar_url : '/assets_common/img/common/user-default-icon.svg'
    }
  }
}
</script>

<style lang="scss" src="./userInfo.scss"></style>



// WEBPACK FOOTER //
// src/components/molecules/userInfo/userInfo.vue